<script>
	export let v;
	export let muted = n => false;
	export let click = null;

	$: numbers = v.sort()
</script>

<span>
	{#each numbers as number}
		{#if click === null}
			<span class="badge {muted(number) ? 'badge-secondary' : 'badge-primary'} m-1">
				{ number }
			</span>
		{:else}
			<a href="#" on:click|preventDefault={click(number, !muted(number))}
				><span class="badge {muted(number) ? 'badge-secondary' : 'badge-primary'} m-1">
					{ number }
				</span></a
			>
		{/if}
	{:else}
		<span class="badge badge-danger m-1">
			∅
		</span>
	{/each}
</span>
